export function objectToFormData(obj: any, form?: FormData, namespace?: string): FormData {
  const formData = form || new FormData()

  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue

    const value = obj[key]
    if (value === undefined || value === null) continue

    const formKey = namespace ? `${namespace}[${key}]` : key

    if (value instanceof Date) {
      formData.append(formKey, value.toISOString())
    } else if (value instanceof File || value instanceof Blob) {
      formData.append(formKey, value)
    } else if (Array.isArray(value)) {
      value.forEach((element, index) => {
        const arrayKey = `${formKey}[${index}]`
        if (typeof element === 'object' && !(element instanceof File)) {
          objectToFormData(element, formData, arrayKey)
        } else {
          formData.append(arrayKey, element)
        }
      })
    } else if (typeof value === 'object') {
      objectToFormData(value, formData, formKey)
    } else {
      formData.append(formKey, String(value))
    }
  }

  return formData
}
